var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_c('div',{class:['symbol', _vm.visible]}),_vm._v(" "),_c('sequential-entrance',{attrs:{"delay":_vm.delay,"animation":"wordIn"}},_vm._l((_vm.titleArr()),function(item){return _c('span',{key:item.id,staticClass:"word is-lato",class:_vm.custom},[_vm._v(_vm._s(item))])}),0)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24b18b70","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Title.vue
// module id = null
// module chunks = 